// eslint-disable-next-line import/no-anonymous-default-export
export default (user = [], action) => {
  switch (action.type) {
    case "GET_ALL_USER":
      return action.payload;
    case "CREATE_FRESH_USER":
      return [...user, action.payload];
    case "UPDATE_SELECTED_USER":
      return [...user, action.payload];
    case "DELETE_SELECTED_USER":
      return user.filter((lo) => lo._id !== action.payload);
    default:
      return user;
  }
};
